import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import { viewModes, formatTime } from "../../common/common";

import { IcLocationSearch, IcCalendarSearch, IcChevrDown, IcChevrLeft } from "../../common/svg";

const QuicklySearchWD = (props) => {
	const {
		carFinding,
		visible,
		viewMode,
		addressPlaceHolder,
		addressBanner,
		startDate,
		endDate,
		isIOS,
		WDCalendarTemplate,
		wrapperSelectCF,
		isSelectHour,
		selectHour,
		durationTimeArr,
		formatWdAddress,
		startTime,
		endTime,
		prevUrl
	} = props;
	const {
		showAddressBox,
		onStartDateChange,
		toggleDurationTimeBox,
		onSelectHourChange,
		onEndDateChange,
		openCalendar,
	} = props; //function

	return (
		<div
			className={`finding-section ${viewMode === viewModes.LIST ? "fixed" : ""} ${visible ? "" : "scroll-top"}`}
			id="home-box">
			<div className="m-container">
				<div className="finding-container">
					<a className="wrap-svg back" onClick={() => {
							if (prevUrl !== "") {
								window.location.href = prevUrl;
							} else {
								props.history.back()}
							}}>
						<IcChevrLeft />
					</a>
					<div className="finding-info">
						<div className="input-form pointer" onClick={showAddressBox}>
							<div className="wrap-svg">
								<IcLocationSearch />
							</div>
							<div className="here-autocomplete">
								<p>
									{carFinding.filter.address[0] !== ""
										? formatWdAddress
										: addressPlaceHolder.includes("Nhập địa chỉ")
										? addressBanner
										: "Vị trí trên bản đồ."}
								</p>
							</div>
						</div>

						<div className="time-form">
							<div className="time-form__item" onClick={openCalendar}>
								<div className="wrap-svg">
									<IcCalendarSearch />
								</div>
								<div className="time-value">
								
									{startTime >= 0  ? formatTime(startTime) : carFinding.filter.startTime ?  formatTime(carFinding.filter.startTime) : 'Chọn giờ'},{" "}
									{startDate
										? startDate.format("DD/MM/YYYY")
										: carFinding.filter.startDate
										? carFinding.filter.startDate.format("DD/MM/YYYY")
										: "Chọn ngày"}{" "}
									- {endTime >= 0 ? formatTime(endTime) : carFinding.filter.endTime ? formatTime(carFinding.filter.endTime) : 'Chọn giờ'},{" "}
									{endDate
										? endDate.format("DD/MM/YYYY")
										: carFinding.filter.endDate
										? carFinding.filter.endDate.format("DD/MM/YYYY")
										: "Chọn ngày"}
								</div>
							</div>

							{/* {startDate ? (
											<DateRangePicker
												initialSettings={{
													startDate: startDate ? startDate : carFinding.filter.startDate,
													endDate: startDate ? startDate : carFinding.filter.startDate,
													minDate: moment(),
													maxDate: moment().add(3, "months"),
													timePicker: true,
													timePicker24Hour: true,
													timePickerIncrement: 30,
													singleDatePicker: true,

													isIOs: isIOS,
													template: WDCalendarTemplate,
													buttonClasses: ["btn btn--m btn-primary"],
													locale: {
														applyLabel: "Áp dụng",
													},
													opens: "center",
													parentEl: "#home-box",
													linkedCalendars: true,
													singelSelect: true,
												}}
												onHide={onStartDateChange}>
												<div className="time-form__item">
													<div className="wrap-svg">
														<IcCalendarSearch />
													</div>
													<div className="time-value">
														{carFinding.filter.startDate
															? carFinding.filter.startDate.format("DD/MM/YYYY")
															: "Chọn ngày"}
													</div>
													<div className="line"> </div>
													<div className="time-value">
														{carFinding.filter.startDate
															? carFinding.filter.startDate.format("HH:mm")
															: "Chọn giờ"}
													</div>
												</div>
											</DateRangePicker>
										) : (
											<LoadingInlineTime />
										)} */}

							{/* <div className="time-custom" ref={wrapperSelectCF}>
											<div
												className="select"
												onClick={() => toggleDurationTimeBox(isSelectHour)}
												style={{ display: "flex", alignItems: "center" }}>
												{selectHour > 0 ? <span>{convertToHourText(selectHour)}</span> : "Tùy chỉnh"}
												<div className="wrap-svg">
													<IcChevrDown />
												</div>
											</div>

											{isSelectHour && (
												<div className="options">
													{durationTimeArr &&
														durationTimeArr.map((time) => (
															<div className="custom-radio" key={time}>
																<input
																	type="radio"
																	id={`cf_time_${time}`}
																	name="rSelectHour"
																	value={time}
																	checked={selectHour === time}
																	onChange={() => onSelectHourChange(time)}
																/>
																{time > 0 ? (
																	<label htmlFor={`cf_time_${time}`}>
																		{convertToHourText(time)}
																		<span className="note-time">
																			{getEndDatewd(time, startDate).format("HH:mm DD/MM/YYYY")}
																		</span>
																	</label>
																) : (
																	<label htmlFor={`cf_time_${time}`}>Tùy chỉnh</label>
																)}
															</div>
														))}
												</div>
											)}
										</div> */}

							{/* {selectHour > 0 && (
											<div className="time-form__item">
												<div className="time-value no-cursor" style={{ cursor: "unset" }}>
													{endDate
														? endDate.format("DD/MM/YYYY")
														: carFinding.filter.endDate
														? carFinding.filter.endDate.format("DD/MM/YYYY")
														: "Chọn ngày"}
												</div>
												<div className="line"></div>
												<div className="time-value no-cursor" style={{ cursor: "unset" }}>
													{endDate
														? endDate.format("HH:mm")
														: carFinding.filter.endDate
														? carFinding.filter.endDate.format("HH:mm")
														: "Chọn giờ"}
												</div>
											</div>
										)} */}

							{/* {selectHour == 0 && endDate && (
											<DateRangePicker
												initialSettings={{
													startDate: endDate ? endDate : carFinding.filter.endDate,
													endDate: endDate ? endDate : carFinding.filter.endDate,
													minDate: moment(),
													maxDate: moment().add(3, "months"),
													timePicker: true,
													timePicker24Hour: true,
													timePickerIncrement: 30,
													singleDatePicker: true,

													isIOs: isIOS,
													template: WDECalendarTemplate,
													buttonClasses: ["btn btn--m btn-primary"],
													locale: {
														applyLabel: "Áp dụng",
													},
													opens: "center",
													parentEl: "#home-box",
													linkedCalendars: true,
													singelSelect: true,
												}}
												onHide={onEndDateChange}>
												<div className="time-form__item">
													<div className="time-value">
														{endDate
															? endDate.format("DD/MM/YYYY")
															: carFinding.filter.endDate
															? carFinding.filter.endDate.format("DD/MM/YYYY")
															: "Chọn ngày"}
													</div>
													<div className="line"></div>
													<div className="time-value">
														{endDate
															? endDate.format("HH:mm")
															: carFinding.filter.endDate
															? carFinding.filter.endDate.format("HH:mm")
															: "Chọn giờ"}
													</div>
												</div>
											</DateRangePicker>
										)} */}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapState = (state) => {
	return {
		carFinding: state.carFinding,
	};
};

export default withRouter(connect(mapState)(QuicklySearchWD));
